export const ScreenBreakpoints = {
    MOBILE: '500',
};
